import gql from 'graphql-tag';
import { Company360FullFragment } from '../fragments/Company360FullFragment';

export const Company360DetailQuery = gql`
	query Company360DetailQuery($id: ID!) {
		entity: node(id: $id) {
			...Company360FullFragment
		}
	}
	${Company360FullFragment}
`;